import {Button, OverlayTrigger, Popover} from "react-bootstrap";
import React from "react";
import {format, parseISO} from "date-fns";

export const UsersList = ({users, indicatorId, handleDeleteUser, label}) => {
    return (
        <OverlayTrigger trigger="click" placement="left" overlay={
            <Popover>
                <Popover.Body className="p-1">
                    <div className="d-flex flex-column gap-1">
                        { users.map((user, index) =>
                            <React.Fragment key={user.id}>
                                {index === 0 && (
                                    <div className="p-2 border-bottom">
                                        <b>Prazo:</b> {user.deadline && format(parseISO(user.deadline), 'dd/MM/yyyy')}
                                    </div>
                                )}
                                <div className="d-flex justify-content-between px-2 p-1">
                                    <div>
                                        <i className={`bi ${user.finished ? 'bi-check-circle text-success' : 'bi-x-circle text-danger'} me-2`}/>
                                        <span className="text-start">{user.username}</span>
                                    </div>

                                    <i
                                        className="bi bi-trash text-danger ms-4"
                                        role="button"
                                        onClick={() => handleDeleteUser(user.id, user.type, user.username, indicatorId)}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </Popover.Body>
            </Popover>
        }>
            <Button variant="success" size="sm" className="text-nowrap">
                {label}
            </Button>
        </OverlayTrigger>
    )
}